import { IListItem } from "@nkr/models/list-item";
import { UserGroup } from "@nkr/enums/index";
import { AuthActionCreators, IGet } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

export interface ICoachFilterCenter {
    id: number;
    alias: string;
}

interface IFilterOptions {
    micrositeTypeList: IListItem[];
    languageList: IListItem[];
    commStatusList: IListItem[];
    coachStatusList: IListItem[];
    statusList: IListItem[];
    eventTypeList: IListItem[];
    centerList: ICoachFilterCenter[];
}

interface IRetVal extends IFilterOptions {
    loading: boolean;
    error: string;
}

const defaultOptions: IFilterOptions = {
    micrositeTypeList: [],
    languageList: [],
    commStatusList: [],
    coachStatusList: [],
    statusList: [],
    eventTypeList: [],
    centerList: []
};

let cache: IFilterOptions | null = null;

const useCoachFilterLookupData = (): IRetVal => {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [options, setOptions] = useState<IFilterOptions>(cache ?? defaultOptions);

    useEffect(() => {
        if (cache) {
            return;
        }

        setLoading(true);
        setError('');

        const fetchData = async () => {
            const config: IGet = { url: `${__API__}/microsite/coach/filter-options` };

            try {
                const response = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.results && response.data.success) {
                    const results = response.data.results;
                    results.statusList = results.statusList.filter(f => !f.userGroups.some(x => UserGroup.Admin));
                    cache = results;
                    setOptions(cache);
                } else {
                    setError('Unable to load filter options');
                }
            } catch (err) {
                setError(err?.message ?? 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { loading, error, ...options };
}

export default useCoachFilterLookupData;
